export default __webpack_public_path__ + "2466b9171bf98dcf59706965d98c2cd4.png";